import { ReapitConnectSession } from '@reapit/connect-session'
import { BASE_HEADERS, URLS } from '../constants/api'
import { IReapitProperty } from '../types/desktopProcess'
import { queryBuilder } from '../utils/common'

interface IGetPropertiesResponse {
  _embedded: IReapitProperty[]
  pageNumber: number
  pageSize: number
  pageCount: number
  totalPageCount: number
  totalCount: number
}

const getProperties = async (
  session: ReapitConnectSession,
  params: {
    pageSize?: number
    pageNumber?: number
    sortBy?: string
    name?: string
    active?: boolean
    address?: string
  },
): Promise<IGetPropertiesResponse> => {
  const requestParams = { ...params }
  if (!requestParams.sortBy) requestParams.sortBy = 'modified'
  if (requestParams.active == undefined) requestParams.active = true
  const response = await fetch(
    `${window.reapit.config.platformApiUrl}${URLS.PROPERTIES}?${queryBuilder(requestParams)}`,
    {
      method: 'GET',
      headers: {
        ...BASE_HEADERS,
        Authorization: `Bearer ${session.accessToken}`,
      },
    },
  )

  if (response.ok) {
    const responseJson = response.json()
    return responseJson
  }

  throw new Error((await response.json()).description)
}

const getPropertyById = async (session: ReapitConnectSession, propertyId: string): Promise<IReapitProperty> => {
  const response = await fetch(
    `${window.reapit.config.platformApiUrl}/properties/${propertyId}?embed=documents&embed=landlord&embed=negotiator&embed=vendor&embed=offices&embed=tenancies`,
    {
      method: 'GET',
      headers: {
        ...BASE_HEADERS,
        Authorization: `Bearer ${session.accessToken}`,
      },
    },
  )

  if (response.ok) {
    const responseJson = response.json()
    return responseJson
  }

  throw new Error((await response.json()).description)
}

export const PropertyApiService = {
  getProperties,
  getPropertyById,
}
